var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.0488V16.0488H5.5V11.0488H8.5Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C8.1097 0 9.04121 0.79858 10.9043 2.39551L11.9043 3.25293C12.9351 4.13648 13.4511 4.57814 13.7256 5.1748C14 5.77154 14 6.45084 14 7.80859V12.0488C14 13.9344 13.9998 14.8771 13.4141 15.4629C12.8825 15.9944 12.0571 16.0404 10.5 16.0449V11.0488C10.5 9.94426 9.60457 9.04883 8.5 9.04883H5.5C4.39543 9.04883 3.5 9.94426 3.5 11.0488V16.0449C1.94288 16.0404 1.11748 15.9944 0.585938 15.4629C0.000157475 14.8771 0 13.9344 0 12.0488V7.80859C0 6.45084 -4.72367e-05 5.77154 0.274414 5.1748C0.548892 4.57814 1.0649 4.13648 2.0957 3.25293L3.0957 2.39551C4.95879 0.79858 5.8903 0 7 0Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.8f104bfba05efa737b74551dd58cf9a8.svg";
export { ForwardRef as ReactComponent };